import React from "react";
import "./resources.css";
import Footer from "../Footer";

const Status = () => {
  const services = [
    { name: "Web Application", status: "Operational" },
    { name: "Authentication", status: "Operational" },
    { name: "Database", status: "Operational" },
    { name: "Invoice PDF Generation", status: "Operational" },
    { name: "Payment Processing", status: "Operational" },
    { name: "AI Assistant", status: "Operational" },
  ];

  return (
    <div className="resource-page">
      <div className="resource-container">
        <h1>Status</h1>
        <p className="resource-subtitle">
          View the current operational status of KostPadi services.
        </p>

        <section className="resource-section">
          <h2>System Status</h2>

          <div className="status-list">
            {services.map((service) => (
              <div className="status-item" key={service.name}>
                <div>
                  <h3>{service.name}</h3>
                  <p>No known issues currently reported.</p>
                </div>

                <span className="status-badge">{service.status}</span>
              </div>
            ))}
          </div>
        </section>

        <section className="resource-section">
          <h2>Incident Reporting</h2>
          <div className="resource-card full">
            <p>
              If you experience service interruptions, failed payments, login
              issues, or data access problems, please contact support with your
              company name, affected module, screenshot, and description of the
              issue.
            </p>

            <p>Email: support@kostpadi.com</p>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Status;
